<script>
  import { mapGetters } from 'vuex';
  import Toggler from '@/components/Toggler';

  export default {
    components: {
      Toggler,
    },

    props: {
      pro: {
        type: Boolean,
        required: false,
        default: false,
      },
    },

    computed: {
      ...mapGetters('coins', [
        'coin',
      ]),
    },

    methods: {
      toggle (value) {
        if (value) {
          return this.$router.push('/negociar/pro');
        }

        return this.$router.push('/negociar');
      }
    },
  };
</script>

<template>
  <header class="container transaction-header">
    <h1 class="transaction-header__title" v-text="coin.title"></h1>

    <div class="transaction-header__item">
      <p class="transaction-header__description">Total aproximado:</p>
      <p class="transaction-header__value" v-text="coin.formated"></p>
    </div>

    <div class="transaction-header__item">
      <p class="transaction-header__description">Saldo disponível:</p>
      <p class="transaction-header__value" v-text="coin.formated"></p>
    </div>

    <div class="transaction-header__item">
      <p class="transaction-header__description">Saldo {{ coin.initial }}:</p>
      <p class="transaction-header__value">2,04534789</p>
    </div>

    <div class="transaction-header__item" v-if="pro">
      <p class="transaction-header__description">Volume:</p>
      <p class="transaction-header__value">R$ 9.356.456,78</p>
    </div>

    <div class="transaction-header__toggler">
      Modo {{ pro ? 'BASIC' : 'PRO' }} <Toggler
        :value="pro"
        @input="toggle"
        />
    </div>
  </header>
</template>

<style lang="scss">
  .transaction-header {
    height: 38px;
    color: #FFF;
    display: flex;
    padding: 0 4px;
    margin: 38px auto;
    align-items: center;

    &__title {
      font-size: 32px;
      font-weight: 300;
      margin-right: 46px;
      letter-spacing: 0.64px;
    }

    &__item {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      &:not(:last-of-type) {
        margin-right: 56px;
      }
    }

    &__description {
      font-size: 14px;
      color: #b2b8c5;
      margin-bottom: 2px;
      letter-spacing: 0.28px;
    }

    &__value {
      opacity: .8;
      letter-spacing: 0.32px;
    }

    &__toggler {
      line-height: 1;
      margin-left: auto;
      margin-right: 23px;

      .toggler {
        margin-left: 23px;
      }
    }
  }
</style>
